import { useCallback, useRef, useState } from 'react'

interface UseControlledParams<T> {
  controlledValue: T | undefined
  defaultValue: T
}

export const useControlled = <T>({
  controlledValue,
  defaultValue,
}: UseControlledParams<T>): [T, (nextValue: T) => void] => {
  const isControlledRef = useRef(false)
  isControlledRef.current = controlledValue !== undefined

  const [uncontrolledValue, setUncontrolledValue] = useState(defaultValue)

  const value = controlledValue !== undefined ? controlledValue : uncontrolledValue

  const setValue = useCallback((nextValue: T) => {
    if (!isControlledRef.current) {
      setUncontrolledValue(nextValue)
    }
  }, [])

  return [value, setValue]
}
